import { catchError, of } from 'rxjs';
import { Handler } from '../../../Shared/Application/UseCases/Handler';
import { credentialsHandler } from '../../../Shared/Domain/credentialsHandler';
export class TryGetCustomerHandler extends Handler {
  constructor(customerRepository, context) {
    super();
    this.customerRepository = customerRepository;
    this.context = context;
  }
  handle() {
    return credentialsHandler(this.context, credentials => {
      return this.customerRepository.getCustomer(credentials);
    }).pipe(catchError(() => {
      return of();
    }));
  }
}
